import React from 'react';
import { PriceOffer, PriceOfferNoDescription } from './PriceOffer';
import { useOffer } from '@/providers/PriceFreezeOfferProvider';
import { selectOfferDuration } from '@/selectors';

export function PriceOfferContainer({ noFeeKey }) {
  const offer = useOffer();
  const days = selectOfferDuration(offer);

  return <PriceOffer money={offer.deposit} days={days} noFeeKey={noFeeKey} />;
}

export function PriceOfferNoDescriptionContainer({ noFeeKey }) {
  const offer = useOffer();
  const days = selectOfferDuration(offer);

  return (
    <PriceOfferNoDescription
      money={offer.deposit}
      days={days}
      noFeeKey={noFeeKey}
    />
  );
}
